{
  "title": "Investiture of Stone",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "6th-level transmutation",
  "level": 6,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Until the spell ends, bits of rock spread across your body, and you gain the following benefits:",
    "You have resistance to bludgeoning, piercing, and slashing damage from nonmagical weapons.",
    "You can use your action to create a small earthquake on the ground in a 15-foot radius centered on you. Other creatures on that ground must succeed on a Dexterity saving throw or be knocked prone.",
    "You can move across difficult terrain made of earth or stone without spending extra movement. You can move through solid earth or stone as if it was air and without destabilizing it, but you can’t end your movement there. If you do so, you are ejected to the nearest unoccupied space, this spell ends, and you are stunned until the end of your next turn."
  ],
  "spellLists": ["druid", "sorcerer", "warlock", "wizard"]
}
